import { useCallback } from "react";

import useAsync from "Common/useAsync";

import { getABTest, getABTestWithoutRolling } from "./api";

import type { ABVariant, ABExperiment } from "./types";

export const useABTest = <T = ABVariant,>(testName: ABExperiment | string) => {
  const asyncFunction = useCallback(() => memoizedGetABTest(testName), [testName]);
  const result = useAsync(asyncFunction);
  const testValue = result.data?.[testName] as T;
  return { ...result, testName, testValue };
};
let cache = {};
export const memoizedGetABTest = (testName) => {
  if (!cache[testName]) {
    cache[testName] = getABTest(testName).then((response) => response.json());
  }

  return cache[testName];
};
export const resetABTestCache = () => (cache = {});
export const useABTestWithoutRolling = <T = ABVariant,>(testName: ABExperiment | string) => {
  const asyncFunction = useCallback(() => getABTestWithoutRolling(testName).then((response) => response.json()), [testName]);
  const result = useAsync(asyncFunction);
  const testValue = result.data?.[testName] as T;
  return { ...result, testName, testValue };
};
